module.exports = __webpack_public_path__ + "img/03.bd712fa0.jpg";